/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { AnimalsPage } from "./AnimalsPage";
import { App } from "./App";

function start() {
	const rootElement = document.getElementById("root");
	if (!rootElement) return;
	const root = createRoot(rootElement);
	const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
	if (currentPath === "/animals") {
		root.render(<AnimalsPage />);
		return;
	}

	root.render(<App />);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", start);
} else {
	start();
}
